export interface ConfirmFeedback {
  feedbackCode: string;
  feedbackDescription: string;
}
